module.exports = __webpack_public_path__ + "assets/70c887f60cabfa29f9b0d556fc925a6a.mp3";